export const GRAYSCALE_FROM_GREEN_CHANNEL = "GRAYSCALE_FROM_GREEN_CHANNEL";
export const GRAYSCALE_BY_LUMA_FORMULA = "GRAYSCALE_BY_LUMA_FORMULA";
export const GREEN_ONLY = "GREEN_ONLY";